__turbopack_context__.v({
  "fieldset": "_2OVRXa_fieldset",
  "filters_close_icon": "_2OVRXa_filters_close_icon",
  "label": "_2OVRXa_label",
  "legend": "_2OVRXa_legend",
  "linear_shadow": "_2OVRXa_linear_shadow",
  "mobile_controls": "_2OVRXa_mobile_controls",
  "mobile_filters": "_2OVRXa_mobile_filters",
  "mobile_filters_button": "_2OVRXa_mobile_filters_button",
  "mobile_filters_title": "_2OVRXa_mobile_filters_title",
  "mobile_sort_by_select": "_2OVRXa_mobile_sort_by_select",
  "radio": "_2OVRXa_radio",
  "radio_label": "_2OVRXa_radio_label",
});
